import { Box, Modal, Typography } from "@mui/material";
import { useTheme  } from "@mui/material/styles";
import { useTranslation } from "react-i18next";
import { style } from "./style";
import { ModalSessionDetailProps } from "./type";
import { ButtonText, Icon } from "../../components";
import SessionAccordionCst from "../../components/SessionAccordionCst";


export function ModalSessionDetail({ open, handleClose, title, size, extraInfo, data, isVirtual }: ModalSessionDetailProps) {
  const theme = useTheme();
  const { t } = useTranslation();
  const displayedExtraInfo = extraInfo?.trim();

  return (
    <Modal
      open={ open }
      onClose={ handleClose }
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      sx={ {
        zIndex: 1400
      } }
    >
      <Box
        sx={ {
          backgroundColor: theme.customColors.backgroundPrimaryLighter,
          border: `2px solid ${ theme.customColors.border }`,
          ...style,
          ...size,
          position: "relative",
          height: "90svh",
          overflow: "auto"
        } }
      >
        <Box sx={ {
          alignItems: "center",
          display: "flex",
          justifyContent: "space-between",
          position: "sticky",
          top: 0,
          p: "1.5rem",
          zIndex: 2,
          backgroundColor: theme.customColors.backgroundPrimaryLighter
        } }>
          <Typography
            id="modal-modal-title"
            variant="h5"
            sx={ {
              fontWeight: 700
            } }>
            { title }
          </Typography>

          <ButtonText
            aria-label={ t("close") }
            sx={ {
              borderRadius:"8px",
              height:"fit-content",
              minWidth:"unset",
              padding:1
            } }
            onClick={ handleClose }
          >
            <Icon
              icon={ "close" }
              size={ 18 }
              color={ theme.customColors.systemSecondary05 }
            />
          </ButtonText>
        </Box>
        <Box sx={ { my: 4, px: "1.5rem" } }>
          { /* eslint-disable-next-line @typescript-eslint/no-explicit-any */ }
          { data?.map((session: any, index: number) => (
            <SessionAccordionCst key={ session.id } isDetail={ true } data={ session } index={ index } isVirtual={ isVirtual } />
          )) }
          { displayedExtraInfo && (
            <Box
              sx={ {
                backgroundColor: theme.customColors.backgroundPrimary,
                border: "1px solid white",
                borderRadius: "4px",
                mt: "1.5rem",
                px: "2rem",
                py: "1rem"
              } }
            >
              <Typography fontWeight={ 600 } mb={ 1 }>
                { t("additional_information") }
              </Typography>
              <Typography sx={ { overflowWrap: "anywhere", whiteSpace: "pre-wrap" } }>
                { displayedExtraInfo }
              </Typography>
            </Box>
          ) }
        </Box>
      </Box>
    </Modal>
  );
}
